<template>
  <header class="header-global fixed-top">
    <modal
      :show.sync="modals.modal1"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h5>Vous ne pouvez pas accéder à vos informations d'utilisateur</h5>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : CLI_INFO</h5>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal1 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <base-nav
      class="navbar-main headroom"
      id="navbar-main"
      :type="navbarType ? navbarType : 'anhod1'"
      effect="dark"
      expand
    >
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/recouvrement">
        <img src="img/brand/logo.png" alt="logo" style="height: 70px;" />
        Arcos
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="javascript:void(0)">
            <img src="img/brand/ours-noir.jpg" id="menu_image" />
          </a>
          <b id="menu_txt" style="color: #222222;">TéléRèglement</b>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <router-link to="/messages/1">
            <a class="nav-link" id="menu_1"
              ><i class="ni ni-email-83"></i> Messages</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/paiement">
            <a class="nav-link" id="menu_2"
              ><i class="ni ni-credit-card"></i> Paiement</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/informations">
            <a class="nav-link" id="menu_3"
              ><i class="ni ni-align-left-2"></i> Informations</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/contact">
            <a class="nav-link" id="menu_4"
              ><i class="ni ni-send"></i> Contact</a
            >
          </router-link>
        </li>
        <li>
          <base-dropdown class="nav-item">
            <a
              role="button"
              slot="title"
              class="nav-link"
              data-toggle="dropdown"
            >
              <i class="ni ni-ui d-lg-none"></i>
              <span class="nav-link-inner--text"
                ><i class="ni ni-single-02"></i
                ><a id="menu_5">Mes informations</a></span
              >
            </a>
            <div class="dropdown-item mb--3" id="menu_5_1">
              <b>Nom : &nbsp;</b>
              {{ nom }}
            </div>
            <div class="dropdown-item mb--3" id="menu_5_2">
              <b>Adresse : &nbsp;</b>
              {{ adresse }}
            </div>
            <div class="dropdown-item mb--3" id="menu_5_3">
              <b>Ville : &nbsp;</b>
              {{ ville }}
            </div>
            <div class="dropdown-item mb--3" id="menu_5_4">
              <b>Code Postal : &nbsp;</b>
              {{ cp }}
            </div>
            <div class="dropdown-item mb--3" id="menu_5_5">
              <b>Téléphone : &nbsp;</b>
              {{ tel }}
            </div>
            <div class="dropdown-item mb--3" id="menu_5_6">
              <b>Mail : &nbsp;</b>
              {{ mail }}
            </div>
            <div
              class="dropdown-item"
              style="text-decoration: underline;"
              @click="Deconnexion"
              id="menu_5_6"
            >
              Se déconnecter
            </div>
          </base-dropdown>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import router from "@/router";
import axios from "axios";
import { HTTP_REQUEST } from "../constants/constantes";
import Modal from "@/components/Modal";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    BaseDropdown,
    Modal,
    CloseButton
  },
  props: {
    navbarType: String
  },
  created: function() {
    this.verifToken();
  },
  data() {
    return {
      nom: "",
      adresse: "",
      ville: "",
      cp: "",
      tel: "",
      mail: "",

      modals: {
        modal1: false
      }
    };
  },
  methods: {
    // Suppression du Token/Soldes
    Deconnexion: function() {
      this.$store.commit("removeToken", this.$store.state.tokens);
      this.$store.commit("removeSolde", this.$store.state.soldes);
      router.push("/login/0/0/0");
    },
    // Vérification du token existant
    verifToken: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let postAction = "action=Verif_CreateToken";
          let postToken = "&token=" + self.$store.state.tokens;
          let postDossier = "&dossier=0";
          let postMotdepasse = "&motdepasse=0";
          let postData = postAction + postToken + postDossier + postMotdepasse;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (
              retourApi.data != "INVALID PARAMS" &&
              retourApi.data != "ERROR"
            ) {
              let data = JSON.parse(retourApi.data);
              let getDataCli = async function() {
                let postAction = "action=getDebiteurInfo";
                let postId = "&debiteur=" + data["deb"];
                let postData = postAction + postId;
                const retourRequete = await axios.post(HTTP_REQUEST, postData);
                return retourRequete;
              };
              getDataCli().then(function(retourApi) {
                if (retourApi.data) {
                  if (retourApi.data == "ERROR_QUERY") {
                    self.nom = "ERREUR";
                    self.adresse = "ERREUR";
                    self.ville = "ERREUR";
                    self.cp = "ERREUR";
                    self.tel = "ERREUR";
                    self.mail = "ERRUR";
                    self.modals.modal1 = true;
                  } else {
                    let data = retourApi.data;
                    self.nom = data["Raison_sociale"];
                    self.adresse = data["Adresse_1"];
                    self.ville = data["Ville"];
                    self.cp = data["CP"];
                    self.mail = data["Mail"];
                    if (data["Mobile"] != "") {
                      self.tel = data["Mobile"];
                    } else {
                      self.tel = data["Telephone"];
                    }
                  }
                }
              });
            }
          }
        });
      }
    }
  }
};
</script>
<style>
.navbar-main.headroom {
  z-index: 9999;
}
@media screen and (min-width: 1000px) {
  #menu_image {
    height: 50px;
  }
  #menu_txt {
    font-size: 1em;
  }
  #menu_1 {
    font-size: 1em;
  }
  #menu_2 {
    font-size: 1em;
  }
  #menu_3 {
    font-size: 1em;
  }
  #menu_4 {
    font-size: 1em;
  }
  #menu_5 {
    font-size: 1em;
  }
  #menu_5_1 {
    font-size: 1em;
  }
  #menu_5_2 {
    font-size: 1em;
  }
  #menu_5_3 {
    font-size: 1em;
  }
  #menu_5_4 {
    font-size: 1em;
  }
  #menu_5_5 {
    font-size: 1em;
  }
  #menu_5_6 {
    font-size: 1em;
  }
}
@media screen and (max-width: 991px) {
  #menu_image {
    height: 45px;
  }
  #menu_txt {
    font-size: 0.7em;
  }
  #menu_1 {
    font-size: 0.8em;
  }
  #menu_2 {
    font-size: 0.8em;
  }
  #menu_3 {
    font-size: 0.8em;
  }
  #menu_4 {
    font-size: 0.8em;
  }
  #menu_5 {
    font-size: 0.8em;
  }
  #menu_5_1 {
    font-size: 0.8em;
  }
  #menu_5_2 {
    font-size: 0.8em;
  }
  #menu_5_3 {
    font-size: 0.8em;
  }
  #menu_5_4 {
    font-size: 0.8em;
  }
  #menu_5_5 {
    font-size: 0.8em;
  }
  #menu_5_6 {
    font-size: 0.8em;
  }
}
@media screen and (max-height: 700px) {
  #menu_image {
    height: 35px;
  }
  #menu_txt {
    font-size: 0.7em;
  }
  #menu_1 {
    font-size: 0.8em;
  }
  #menu_2 {
    font-size: 0.8em;
  }
  #menu_3 {
    font-size: 0.8em;
  }
  #menu_4 {
    font-size: 0.8em;
  }
  #menu_5 {
    font-size: 0.8em;
  }
  #menu_5_1 {
    font-size: 0.8em;
    margin-top: -20px;
  }
  #menu_5_2 {
    font-size: 0.8em;
    margin-top: -30px;
  }
  #menu_5_3 {
    font-size: 0.8em;
    margin-top: -30px;
  }
  #menu_5_4 {
    font-size: 0.8em;
    margin-top: -30px;
  }
  #menu_5_5 {
    font-size: 0.8em;
    margin-top: -30px;
  }
  #menu_5_6 {
    font-size: 0.8em;
    margin-top: -30px;
  }
}
</style>
